"use strict";
var Observable_1 = require('../../Observable');
var take_1 = require('../../operator/take');
Observable_1.Observable.prototype.take = take_1.take;
//# sourceMappingURL=take.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/rxjs/add/operator/take.js
// module id = ../../../../rxjs/add/operator/take.js
// module chunks = 4